/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SuperposherFeatureStatus = 'DISABLED' | 'ENABLED' | 'STOPPED' | 'UNINITIALIZED' | '%future added value';
export type SuperposherPoshmarkCookieStatus =
  | 'RELOGIN_REQUIRED'
  | 'SUSPECTED_BOT'
  | 'USER_ACTION_REQUIRED'
  | 'VALID'
  | '%future added value';
export type SuperposherPoshmarkLinkStatus = 'CONNECTED' | 'DISCONNECTED' | 'UNINITIALIZED' | '%future added value';
export type SuperposherShippingDiscountType = 'DISCOUNTED' | 'FREE' | '%future added value';
export type poshmarkUserLinksQueryVariables = {};
export type poshmarkUserLinksQueryResponse = {
  readonly superposherPoshmarkUserLinks: ReadonlyArray<{
    readonly id: string;
    readonly businessId: string;
    readonly createdAt: number;
    readonly poshmarkUserId: string;
    readonly linkStatus: SuperposherPoshmarkLinkStatus;
    readonly cookieStatus: SuperposherPoshmarkCookieStatus;
    readonly cookieUpdatedAt: number;
    readonly cookieCheckedAt: number;
    readonly poshmarkEmail: string;
    readonly poshmarkUsername: string;
    readonly poshmarkAvatarUrl: string;
    readonly poshmarkFullName: string;
    readonly poshmarkUserCreatedAt: number;
    readonly shareFeatureStatus: SuperposherFeatureStatus;
    readonly shareNotForSaleFeatureStatus: SuperposherFeatureStatus;
    readonly shareForShareFeatureStatus: SuperposherFeatureStatus;
    readonly followForFollowFeatureStatus: SuperposherFeatureStatus;
    readonly followTargetedFeatureStatus: SuperposherFeatureStatus;
    readonly offerToLikersFeatureStatus: SuperposherFeatureStatus;
    readonly shareRandomlyFeatureStatus: SuperposherFeatureStatus;
    readonly shareSkipPartiesFeatureStatus: SuperposherFeatureStatus;
    readonly sharePrioritizePartiesFeatureStatus: SuperposherFeatureStatus;
    readonly sharePrioritizePartiesLoopFeatureStatus: SuperposherFeatureStatus;
    readonly autoRelistingFeatureStatus: SuperposherFeatureStatus;
    readonly listingsBetaFeatureStatus: SuperposherFeatureStatus;
    readonly comparativePrivacyFeatureStatus: SuperposherFeatureStatus;
    readonly vacationModeSharesFeatureStatus: SuperposherFeatureStatus;
    readonly vacationModeFollowsFeatureStatus: SuperposherFeatureStatus;
    readonly vacationModeOffersFeatureStatus: SuperposherFeatureStatus;
    readonly vacationModeRelistsFeatureStatus: SuperposherFeatureStatus;
    readonly relistOldestFirstFeatureStatus: SuperposherFeatureStatus;
    readonly statBucket7DayLookBack: ReadonlyArray<{
      readonly at: number;
      readonly shareToFollowersFinished: number;
      readonly shareToPartiesFinished: number;
      readonly shareForSharesFinished: number;
      readonly followForFollowsFinished: number;
      readonly followUserFollowersFinished: number;
      readonly offerToLikersFinished: number;
      readonly relistingsFinished: number;
      readonly relistingsToPoshmarkFinished: number;
    }>;
    readonly statBucket24HourLookBack: ReadonlyArray<{
      readonly at: number;
      readonly shareToFollowersFinished: number;
      readonly shareToPartiesFinished: number;
      readonly shareForSharesFinished: number;
      readonly followForFollowsFinished: number;
      readonly followUserFollowersFinished: number;
      readonly offerToLikersFinished: number;
      readonly relistingsFinished: number;
      readonly relistingsToPoshmarkFinished: number;
    }>;
    readonly statBucket48HourLookBack: ReadonlyArray<{
      readonly at: number;
      readonly shareToFollowersFinished: number;
      readonly shareToPartiesFinished: number;
      readonly shareForSharesFinished: number;
      readonly followForFollowsFinished: number;
      readonly followUserFollowersFinished: number;
      readonly offerToLikersFinished: number;
      readonly relistingsFinished: number;
      readonly relistingsToPoshmarkFinished: number;
    }>;
    readonly statBucketToday: ReadonlyArray<{
      readonly at: number;
      readonly shareToFollowersFinished: number;
      readonly shareToPartiesFinished: number;
      readonly shareForSharesFinished: number;
      readonly followForFollowsFinished: number;
      readonly followUserFollowersFinished: number;
      readonly offerToLikersFinished: number;
      readonly relistingsFinished: number;
      readonly relistingsToPoshmarkFinished: number;
    }>;
    readonly offerToLikersPercentOff: number | null;
    readonly offerToLikersMinRevenueTarget: number;
    readonly offerToLikersShippingDiscountType: SuperposherShippingDiscountType;
    readonly vacationHold: boolean;
    readonly listingsScrapeAdhoc: boolean;
    readonly userScrapeAdhoc: boolean;
    readonly shareJail: boolean;
    readonly maxDailyShares: number;
    readonly availableListingsCount: number;
    readonly weeklySalesRank: number | null;
    readonly weeklySalesScore: number | null;
    readonly monthlySalesRank: number | null;
    readonly monthlySalesScore: number | null;
    readonly relistInterval: number;
    readonly defaultOfferConfigurationId: string | null;
    readonly noDiscountOfferConfigurationId: string | null;
    readonly tld: string;
  }>;
};
export type poshmarkUserLinksQuery = {
  readonly response: poshmarkUserLinksQueryResponse;
  readonly variables: poshmarkUserLinksQueryVariables;
};

/*
query poshmarkUserLinksQuery {
  superposherPoshmarkUserLinks {
    id
    businessId
    createdAt
    poshmarkUserId
    linkStatus
    cookieStatus
    cookieUpdatedAt
    cookieCheckedAt
    poshmarkEmail
    poshmarkUsername
    poshmarkAvatarUrl
    poshmarkFullName
    poshmarkUserCreatedAt
    shareFeatureStatus
    shareNotForSaleFeatureStatus
    shareForShareFeatureStatus
    followForFollowFeatureStatus
    followTargetedFeatureStatus
    offerToLikersFeatureStatus
    shareRandomlyFeatureStatus
    shareSkipPartiesFeatureStatus
    sharePrioritizePartiesFeatureStatus
    sharePrioritizePartiesLoopFeatureStatus
    autoRelistingFeatureStatus
    listingsBetaFeatureStatus
    comparativePrivacyFeatureStatus
    vacationModeSharesFeatureStatus
    vacationModeFollowsFeatureStatus
    vacationModeOffersFeatureStatus
    vacationModeRelistsFeatureStatus
    relistOldestFirstFeatureStatus
    statBucket7DayLookBack {
      at
      shareToFollowersFinished
      shareToPartiesFinished
      shareForSharesFinished
      followForFollowsFinished
      followUserFollowersFinished
      offerToLikersFinished
      relistingsFinished
      relistingsToPoshmarkFinished
    }
    statBucket24HourLookBack {
      at
      shareToFollowersFinished
      shareToPartiesFinished
      shareForSharesFinished
      followForFollowsFinished
      followUserFollowersFinished
      offerToLikersFinished
      relistingsFinished
      relistingsToPoshmarkFinished
    }
    statBucket48HourLookBack {
      at
      shareToFollowersFinished
      shareToPartiesFinished
      shareForSharesFinished
      followForFollowsFinished
      followUserFollowersFinished
      offerToLikersFinished
      relistingsFinished
      relistingsToPoshmarkFinished
    }
    statBucketToday {
      at
      shareToFollowersFinished
      shareToPartiesFinished
      shareForSharesFinished
      followForFollowsFinished
      followUserFollowersFinished
      offerToLikersFinished
      relistingsFinished
      relistingsToPoshmarkFinished
    }
    offerToLikersPercentOff
    offerToLikersMinRevenueTarget
    offerToLikersShippingDiscountType
    vacationHold
    listingsScrapeAdhoc
    userScrapeAdhoc
    shareJail
    maxDailyShares
    availableListingsCount
    weeklySalesRank
    weeklySalesScore
    monthlySalesRank
    monthlySalesScore
    relistInterval
    defaultOfferConfigurationId
    noDiscountOfferConfigurationId
    tld
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'at',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'shareToFollowersFinished',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'shareToPartiesFinished',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'shareForSharesFinished',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'followForFollowsFinished',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'followUserFollowersFinished',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'offerToLikersFinished',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'relistingsFinished',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'relistingsToPoshmarkFinished',
        storageKey: null,
      },
    ],
    v1 = [
      {
        alias: null,
        args: null,
        concreteType: 'SuperposherPoshmarkUserLink',
        kind: 'LinkedField',
        name: 'superposherPoshmarkUserLinks',
        plural: true,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'businessId',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'createdAt',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'poshmarkUserId',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'linkStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'cookieStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'cookieUpdatedAt',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'cookieCheckedAt',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'poshmarkEmail',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'poshmarkUsername',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'poshmarkAvatarUrl',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'poshmarkFullName',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'poshmarkUserCreatedAt',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'shareFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'shareNotForSaleFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'shareForShareFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'followForFollowFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'followTargetedFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'offerToLikersFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'shareRandomlyFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'shareSkipPartiesFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'sharePrioritizePartiesFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'sharePrioritizePartiesLoopFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'autoRelistingFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'listingsBetaFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'comparativePrivacyFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'vacationModeSharesFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'vacationModeFollowsFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'vacationModeOffersFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'vacationModeRelistsFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'relistOldestFirstFeatureStatus',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'SuperposherStatBucket',
            kind: 'LinkedField',
            name: 'statBucket7DayLookBack',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'SuperposherStatBucket',
            kind: 'LinkedField',
            name: 'statBucket24HourLookBack',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'SuperposherStatBucket',
            kind: 'LinkedField',
            name: 'statBucket48HourLookBack',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'SuperposherStatBucket',
            kind: 'LinkedField',
            name: 'statBucketToday',
            plural: true,
            selections: v0 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'offerToLikersPercentOff',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'offerToLikersMinRevenueTarget',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'offerToLikersShippingDiscountType',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'vacationHold',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'listingsScrapeAdhoc',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'userScrapeAdhoc',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'shareJail',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'maxDailyShares',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'availableListingsCount',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'weeklySalesRank',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'weeklySalesScore',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'monthlySalesRank',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'monthlySalesScore',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'relistInterval',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'defaultOfferConfigurationId',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'noDiscountOfferConfigurationId',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'tld',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'poshmarkUserLinksQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'poshmarkUserLinksQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '7133ff8a751a5f53e9bcb647c3168472',
      id: null,
      metadata: {},
      name: 'poshmarkUserLinksQuery',
      operationKind: 'query',
      text: 'query poshmarkUserLinksQuery {\n  superposherPoshmarkUserLinks {\n    id\n    businessId\n    createdAt\n    poshmarkUserId\n    linkStatus\n    cookieStatus\n    cookieUpdatedAt\n    cookieCheckedAt\n    poshmarkEmail\n    poshmarkUsername\n    poshmarkAvatarUrl\n    poshmarkFullName\n    poshmarkUserCreatedAt\n    shareFeatureStatus\n    shareNotForSaleFeatureStatus\n    shareForShareFeatureStatus\n    followForFollowFeatureStatus\n    followTargetedFeatureStatus\n    offerToLikersFeatureStatus\n    shareRandomlyFeatureStatus\n    shareSkipPartiesFeatureStatus\n    sharePrioritizePartiesFeatureStatus\n    sharePrioritizePartiesLoopFeatureStatus\n    autoRelistingFeatureStatus\n    listingsBetaFeatureStatus\n    comparativePrivacyFeatureStatus\n    vacationModeSharesFeatureStatus\n    vacationModeFollowsFeatureStatus\n    vacationModeOffersFeatureStatus\n    vacationModeRelistsFeatureStatus\n    relistOldestFirstFeatureStatus\n    statBucket7DayLookBack {\n      at\n      shareToFollowersFinished\n      shareToPartiesFinished\n      shareForSharesFinished\n      followForFollowsFinished\n      followUserFollowersFinished\n      offerToLikersFinished\n      relistingsFinished\n      relistingsToPoshmarkFinished\n    }\n    statBucket24HourLookBack {\n      at\n      shareToFollowersFinished\n      shareToPartiesFinished\n      shareForSharesFinished\n      followForFollowsFinished\n      followUserFollowersFinished\n      offerToLikersFinished\n      relistingsFinished\n      relistingsToPoshmarkFinished\n    }\n    statBucket48HourLookBack {\n      at\n      shareToFollowersFinished\n      shareToPartiesFinished\n      shareForSharesFinished\n      followForFollowsFinished\n      followUserFollowersFinished\n      offerToLikersFinished\n      relistingsFinished\n      relistingsToPoshmarkFinished\n    }\n    statBucketToday {\n      at\n      shareToFollowersFinished\n      shareToPartiesFinished\n      shareForSharesFinished\n      followForFollowsFinished\n      followUserFollowersFinished\n      offerToLikersFinished\n      relistingsFinished\n      relistingsToPoshmarkFinished\n    }\n    offerToLikersPercentOff\n    offerToLikersMinRevenueTarget\n    offerToLikersShippingDiscountType\n    vacationHold\n    listingsScrapeAdhoc\n    userScrapeAdhoc\n    shareJail\n    maxDailyShares\n    availableListingsCount\n    weeklySalesRank\n    weeklySalesScore\n    monthlySalesRank\n    monthlySalesScore\n    relistInterval\n    defaultOfferConfigurationId\n    noDiscountOfferConfigurationId\n    tld\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'a142cebc31cedd8632c6b07398dd2fc7';
export default node;
